import RemoveStoreAccess from './RemoveStoreAccess'
export default RemoveStoreAccess
